import request from './request';
import { serialize, isArray, log } from '@/utils';

function get(url) {
	const { promise } = request(url, {
		method: 'get',
		crossOrigin: true
	});

	return promise
		.then(response =>
			//return text and parse later due to a parsing issue with capacitor http plugin
			response.text()
		)
		.then(response => {
			return typeof response === 'string'
				? JSON.parse(response)
				: typeof response === 'object'
				? response
				: {};
		})
		.catch(error => log(error));
}

function post(url, data) {
	const { promise, abort } = request(url, {
		method: 'post',
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
		},
		body: serialize(data)
	});

	return promise
		.then(response => response.json())
		.then(response => {
			return response;
		});
}

function api({
	formKey,
	domain,
	cacheDomain = 'cacheorcheck.mopinion.com',
	customDomain,
	feedbackDomain = 'survey.mopinion.com',
	webView,
	noCache,
	refresh
}) {
	const api = {
		cache: `https://${cacheDomain}/survey/public`,
		domain: `https://${customDomain ?? domain}/survey/public`,
		send: `https://${feedbackDomain}/api/1/data`
	};

	function whichApi(useApi, useDomainApi) {
		if (useApi === 'send') return api.send;

		if (
			noCache ||
			useDomainApi ||
			['beta.mopinion.com', 'accept.mopinion.com'].indexOf(domain) > -1
		) {
			return api.domain;
		}

		return api[useApi];
	}

	return {
		getConfig(withBase, useDomainApi) {
			return get(
				`${whichApi('cache', useDomainApi)}/json-config?key=${formKey}&domain=${domain}${
					webView ? '&webView=true' : ''
				}${withBase ? '&withBase=true' : ''}${refresh ? '&' + Date.now() : ''}`
			);
		},
		getEmoji(blockId) {
			return get(whichApi('cache') + `/emoji?blockId=${blockId}&domain=${domain}`);
		},
		getIcons(icons) {
			icons = isArray(icons) ? icons : [icons];
			return get(whichApi('cache') + `/icons?icons=${icons.join(',')}&domain=${domain}`);
		},
		validateReCaptcha(data) {
			return post(whichApi('domain') + '/validate-recaptcha', data);
		},
		validateBusinessEmail(data) {
			return post(whichApi('domain') + '/validate-business-email', data);
		}
	};
}

export default api;
